export const TICKET_CATEGORY_REQUEST = "TICKET_CATEGORY_REQUEST";
export const TICKET_CATEGORY_SUCCESS = "TICKET_CATEGORY_SUCCESS";
export const TICKET_CATEGORY_FAILURE = "TICKET_CATEGORY_FAILURE";

